import React, { useCallback, useEffect, useRef } from "react";
import ReactPlayer from "react-player";

const ReactVideoPlayerForMobile = (props) => {
  const playerRef = useRef();

  const setVideoPlayed = (progress) => {
    if (window.ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "onPlay", ...progress })
      );
    }
  };

  const onStart = (progress) => {
    if (window.ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "onStart", ...progress })
      );
    }
  };

  const handlePause = (progress) => {
    if (window.ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "onPause", ...progress })
      );
    }
  };

  const handleDuration = (progress) => {
    if (window.ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "onDuration", ...progress })
      );
    }
  };

  const handleEnded = (progress) => {
    if (window.ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "onEnd", ...progress })
      );
    }
  };

  const handleProgess = (progress) => {
    console.log(progress, "progess.playedSeconds");
    if (window.ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "onProgress", ...progress })
      );
    }
  };

  const onReady = useCallback(() => {
    if (!!props.seekTo) {
      playerRef.current.seekTo(props.seekTo, "seconds");
      playerRef.current.state.showPreview = true;
      console.log(playerRef.current.state.showPreview, "playerRef.current");
    }
  }, [props.url]);

  return (
    <div className="wrapper">
      <ReactPlayer
        ref={playerRef}
        controls
        className="player"
        url={props.url}
        width="100vw"
        height="100vh"
        stopOnUnmount
        pip
        playsinline
        onReady={onReady}
        onProgress={handleProgess}
        onEnded={handleEnded}
        onPause={handlePause}
        onDuration={handleDuration}
        onPlay={setVideoPlayed}
        onStart={onStart}
      />
    </div>
  );
};

function App() {
  let search = document.location.search;
  const bg_color = new URLSearchParams(search).get("bg_color");
  const timeToSeek = new URLSearchParams(search).get("seek_to");
  const video_url = new URLSearchParams(search).get("video_url");
  const embed_code = new URLSearchParams(search).get("embed_code");

  useEffect(() => {
    document.body.style.background = `#${bg_color}`;
    let iframe = document.getElementsByTagName("iframe")[0];
    if (iframe) {
      let main_element = document.querySelector(".mobile_video_embed_code");
      let firstDivElement = main_element
        ? main_element.querySelector("div")
        : null;
      firstDivElement.style.padding = 0;
      firstDivElement.style.position = "unset";
      iframe.style.maxHeight = "100%";
    }
  }, []);

  if (embed_code) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: embed_code,
        }}
        className="mobile_video_embed_code"
      ></div>
    );
  }

  return <ReactVideoPlayerForMobile url={video_url} seekTo={timeToSeek} />;
}

export default App;
